// **************************************************
//
// LOADING
//
// **************************************************
export const loadProgress = function(state, progress) {
  state.loading.progress = progress
}

export const loadComplete = function(state) {
  state.loading.completed = true
}

// **************************************************
//
// GAME STATE
//
// **************************************************
// export const setProgress = function(state, progress) {
//   state.progress = progress
// }

// export const setVelocity = function(state, velocity) {
//   state.velocity = velocity
// }

// export const setStage = function(state, stage) {
//   state.stage = stage
// }

// export const setTime = function(state, time) {
//   state.time = time
// }

export const setRanking = function(state, ranking) {
  state.ranking = Object.assign(state.ranking, ranking)
  state.ranking.percentile = state.ranking.percentile
}

// export const restart = function(state) {
//   state.stage = STAGES.STAGE1
//   state.startTime = Date.now()
// }

// export const end = function(state) {
//   state.stage = STAGES.END
//   state.ended = true
// }




// WEBPACK FOOTER //
// ./src/store/game/mutations.js